<template>
  <!-- 轮播图 -->
  <div class="swiper-box" :style="{ height: height + 'px' }">
    <div class="swiper-container banner-swiper">
      <div class="swiper-wrapper">
        <div
          class="swiper-slide"
          v-for="(item, index) in swiperList"
          :key="index"
        >
          <img
            class="swiper-lazy"
            :data-src="item.banner"
            alt="轮播图"
          />
          <!-- <el-image style="width: 100%; height:100%"   class="swiper-lazy" :src="item.banner" fit="cover"></el-image> -->
          <!-- <div class="swiper-lazy-preloader"></div> -->
        </div>
      </div>
      <!-- 如果需要分页器 -->
      <div class="swiper-pagination"></div>

      <!-- 如果需要导航按钮 -->
      <div class="swiper-button-prev"></div>
      <div class="swiper-button-next"></div>
    </div>
  </div>
</template>

<script>
import Swiper from "swiper";
import { getBanner } from "@/api/index";
export default {
  name: "swiper",
  props: {
    bsnnerType: {
      type: Number,
      default: 0
    },
    height: {
      type: Number,
      default: 400
    }
  },
  watch: {
    bsnnerType(newVal, oldVal) {
      this.getBannerData(newVal);
    }
  },
  data() {
    return {
      swiperList: []
    };
  },
  mounted() {
    this.getBannerData(this.bsnnerType);
  },
  methods: {
    //轮播图
    getBannerData(type) {
      let language = window.localStorage.getItem("locale");
      getBanner({ type, language }).then(res => {
        console.log("参数");
        console.log(res.data);
        this.swiperList = res.data;
        this.initSwiper();
      });
    },
    initSwiper() {
      this.$nextTick(() => {
        /* banner-swiper */
        new Swiper(".banner-swiper", {
          loop: true, // 循环模式选项
          effect: "vertical",
          //自动播放
          autoplay: {
            delay: 3000,
            stopOnLastSlide: false,
            disableOnInteraction: false
          },
          // 如果需要分页器
          pagination: {
            el: ".swiper-pagination",
            clickable: true
          },
          // 如果需要前进后退按钮
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev"
          },
          // 延迟加载
          lazy: {
            loadPrevNext: true
          },
          observer: true, //修改swiper自己或子元素时，自动初始化swiper
          observeParents: true //修改swiper的父元素时，自动初始化swiper
        });
      });
    }
  }
};
</script>

<style scoped>
/* 轮播图 */
/* .swiper-box {
    height: 400px;
  } */
.swiper-box .banner-swiper {
  width: 100%;
  height: 100%;
}
.swiper-box .banner-swiper .swiper-slide img {
  width: 100%;
  height: 100%;
}
.swiper-box .banner-swiper .swiper-slide {
  position: relative;
}
.swiper-box .banner-swiper .swiper-slide-title {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 999999999;
  width: 100%;
  height: 100%;
  color: #fff;
  background: rgba(51, 51, 51, 0.534);
  text-align: center;
  line-height: 80px;
}
.swiper-box .banner-swiper .swiper-slide-title > h1 {
  font-size: 50px;
  margin-top: 12%;
}
.swiper-box .banner-swiper .swiper-slide-title > p {
  font-size: 20px;
  margin-top: 1%;
  font-weight: 700;
}

/* 媒体查询（手机） */
@media screen and (max-width: 768px) {
  .swiper-box {
    height: 200px;
  }
}

/* 媒体查询（平板） */
@media screen and (min-width: 768px) and (max-width: 996px) {
  .swiper-box {
    height: 400px;
  }
}

.swiper-lazy {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>



// WEBPACK FOOTER //
// src/components/swiper.vue